import { QueryClient as TSQueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, type PropsWithChildren, Suspense, useEffect, useState } from "react";
import { Portal } from "../components/ui/portal.tsx";
import { isDevelopment } from "../utils/env.ts";

const RTK_ID = "react-query-devtools-portal";

const ReactQueryDevtoolsProduction = lazy(() =>
    import("@tanstack/react-query-devtools/build/modern/production.js").then((d) => ({
        default: d.ReactQueryDevtools,
    })),
);

export default function QueryClient({ children }: PropsWithChildren) {
    const [showDevTools, setShowDevTools] = useState<boolean>(isDevelopment());
    const [queryClient] = useState(() => {
        return new TSQueryClient({
            defaultOptions: {
                queries: {
                    retry: false,
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                },
            },
        });
    });

    useEffect(() => {
        window.toggleDevtools = () => setShowDevTools((current) => !current);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <Portal portalId={RTK_ID} renderPortal={showDevTools}>
                <Suspense fallback={null}>
                    <ReactQueryDevtoolsProduction />
                </Suspense>
            </Portal>
        </QueryClientProvider>
    );
}
